/**
 * @generated SignedSource<<f1f82cc0fae6280d93f9065afb2bf7c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OptionGroupHeader$data = {
  readonly displayName: string;
  readonly option: {
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "OptionGroupHeader";
};
export type OptionGroupHeader$key = {
  readonly " $data"?: OptionGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"OptionGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "OptionGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "type": "JiraJqlOptionFieldValue"
};

(node as any).hash = "c4db465dc3b0a691a209bbf2635a74ed";

export default node;
